import {
  TOGGLE_LOADING_SMART_ENGAGE,
  UPDATE_SMART_ENGAGE,
  ISmartEngageBannerStoreState,
  SmartEngageActionTypes,
} from './types';

const initialState: ISmartEngageBannerStoreState = {
  data: null,
  isLoading: false,
};

export default function smartEngageReducer(state = initialState, action: SmartEngageActionTypes) {
  switch (action.type) {
    case TOGGLE_LOADING_SMART_ENGAGE:
      return {
        ...state,
        isLoading: action.actionData,
      };

    case UPDATE_SMART_ENGAGE:
      return {
        ...state,
        data: action.actionData,
      };

    default:
      return state;
  }
}
